import { Filter } from 'src/app/modules/core/store/models/filters.model';
import { IFieldFilterHandler, FieldFilterHandler } from 'src/app/modules/core/services/filter-runtime/field-handlers';

export class BooleanFieldFilterHandler extends FieldFilterHandler implements IFieldFilterHandler {
  constructor() {
    super();
  }

  fieldMatchesFilter(value: any, filter: Filter): boolean {
    const booleanValue = value.toString().toLowerCase() === 'true';
    const booleanFilter = {
      ...filter,
      value: filter.value?.toString().toLowerCase() === 'true'
    };

    const handler = this.comparisonHandlers[filter.operator];

    if (!handler) {
      return true;
    }

    const doesMatch = handler(booleanValue, booleanFilter);

    return doesMatch;
  }
}
